
import makerjs from "makerjs";
function B05(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  console.log("Param==",Param[1].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    B = Param[0].param,L = Param[1].param, R = Param[2].param,
      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,

       b = B * 1 * myZoom,
       l = L * 1 * myZoom,
       r = R * 1 * myZoom,
       // x0 = X*1*myZoom,
       // y0 = Y*1*myZoom;
       x0 = 0, x1 = 0, x2 =b , x3 = b,y0 = 0, y1 = l, y2 = r, y3 =0,glassH = r, glassW = b,h=r,w=b;

   if (b !== 0) {
       var TxtB = B;
   }  if (l !== 0) {
  var TxtL = "L="+L;
}
if (r !== 0) {
    var TxtR = R;
}



   var drawAbnormalShapeB05 = {
       paths: {
        "LeftLine": new makerjs.paths.Line([x0, y0], [x1, y1]),
        "TopLine":new makerjs.paths.Line([x1,y1], [x2,y2]), 
        "RightLine": new makerjs.paths.Line([x2, y2], [x3, y3]),
        "BottomLine": new makerjs.paths.Line([x3, y3], [x0, y0]),
       }
   };
   var drawAbnormalShapeB05MarkL = {
       paths: {
        "RightLine": new makerjs.paths.Line([x0- markShift, y0], [x0- markShift, y1]),
        "RightShortUpline": new makerjs.paths.Line([x0, y0], [x0- 2 * markShift, y0]),
        "RightShortDnline": new makerjs.paths.Line([x1, y1], [x1- 2 * markShift, y1]),
       }
   };
   var drawAbnormalShapeB05MarkR = {
       paths: {
        "RightLine": new makerjs.paths.Line([x3+ markShift, y3], [x2+ markShift, y2]),
        "RightShortUpline": new makerjs.paths.Line([x2, y2], [x2+ 2 * markShift, y2]),
        "RightShortDnline": new makerjs.paths.Line([x3, y3], [x3+ 2 * markShift, y3]),
       }
   };
   var drawAbnormalShapeB05MarkB = {
       paths: {
        "BottomLine": new makerjs.paths.Line([x0, y0- markShift], [x3, y3- markShift]),
        "BotmShortLfline": new makerjs.paths.Line([x0, y0], [x0, y0 - 2 * markShift]),
        "BotmShortRTline": new makerjs.paths.Line([x3, y3], [x3, y3 - 2 * markShift]),
       }
  
   };
   makerjs.model.addCaption(drawAbnormalShapeB05MarkB, TxtB, [x0, y0 - 2 * markShift], [x3, y3 - 2 * markShift]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeB05MarkR, TxtR, [x3 + 2 * markShift, y3], [x2 + 2 * markShift, y2]);//宽度文字
   makerjs.model.addCaption(drawAbnormalShapeB05MarkL, TxtL, [x0-2*markShift, y0], [x1-2*markShift, y1]);//宽度文字
   
  plate={
    models: {
      drawAbnormalShapeB05: drawAbnormalShapeB05,
      }
    };
    markers={
      models: {
        drawAbnormalShapeB05: drawAbnormalShapeB05,
        drawAbnormalShapeB05MarkL: drawAbnormalShapeB05MarkL,
        drawAbnormalShapeB05MarkB:drawAbnormalShapeB05MarkB,
        drawAbnormalShapeB05MarkR:drawAbnormalShapeB05MarkR,
        }
      };
    
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers}  
};


export default B05;